import { render } from "./TermsOfServices.vue?vue&type=template&id=6bd4d7cc"
import script from "./TermsOfServices.vue?vue&type=script&lang=js"
export * from "./TermsOfServices.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__